import { buildQueryString } from "./url";
import "whatwg-fetch";
import { SSO_AUTH_ERROR, FORBIDDEN_TENANT_ERROR } from "../src/utils/auth/authErrorTypes";
import { getTenantFromURL } from "../src/components/common/MultiTenancy/MultiTenancyHelper";
import keycloakManager from "../src/components/login/sso/keycloakManager";
import { getSessionCookies, setSessionCookies } from "../src/components/common/sessions/tokenHelper";
import store from "../src/store";
import { logout } from "../src/components/login/loginActions";

export const ALL_SIMPLE_FETCH_ERRORS = [
    "terminated_client_error",
    "archived_member_error",
    "archived_client_error",
    "archived_division_error",
    "archived_class_error",
    "archived_dependent_person_error"
];

export default async (method, path, { query, body, options = {}, headers }) => {
    let [accessToken, refreshToken] = getSessionCookies();
    const tenantHeader = getTenantFromURL();

    if (accessToken && refreshToken) {
        try {
            [accessToken, refreshToken] = await keycloakManager.refreshTokens(accessToken, refreshToken);
            setSessionCookies(accessToken, refreshToken);
        } catch (e) {
            console.debug("Unabled to fetch new tokens");
        }
    }

    return new Promise((resolve, failure) => {
        let status;

        let apiUrl = path.includes("/v2/") || path.includes("/graphql") ? __APIV2_URL__ : __API_URL__;

        const url = options.localUrl ? path : apiUrl + path + buildQueryString(query, path);
        let requestHeaders = {};

        requestHeaders["tenant"] = tenantHeader;
        if (accessToken) {
            requestHeaders.Authorization = `JWT ${accessToken}`;
        }
        if (refreshToken) {
            requestHeaders["Refresh-Token"] = refreshToken;
        }
        const languageCode = localStorage.getItem("languageCode");
        if (languageCode) {
            requestHeaders["Accept-Language"] = languageCode;
        }
        requestHeaders["Cache-Control"] = "no-cache";
        requestHeaders["Pragma"] = "no-cache";
        switch (options.contentType) {
            case "formData": {
                requestHeaders = { ...requestHeaders, ...headers };
                break;
            }
            default: {
                if (body) {
                    body = JSON.stringify(body);
                }
                requestHeaders = {
                    ...requestHeaders,
                    "content-type": "application/json",
                    accept: "application/json",
                    ...headers,
                };
                break;
            }
        }

        const opt = {
            method,
            body,
            headers: requestHeaders,
            ...options,
        };
        fetch(url, opt)
            .then((response) => {
                status = response.status;
                return response.text();
            })
            .then((data) => {
                if (data) {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        /* at least we tried :-( */
                    }
                }

                if (status >= 400) {
                    failure({ status, data });
                    redirectIfNeeded(data);
                    checkForToastErrors(data);
                } else {
                    resolve(data);
                }
            })
            .catch((e) => {
                redirectIfNeeded(e);
                failure(e);
            });
    });
};

function redirectIfNeeded(data) {
    const detail = data.detail;
    if (detail && detail.error_code == SSO_AUTH_ERROR) {
        logout(`${window.location.origin}/login?timeout=true`);
    } else if (detail && detail.error_code == FORBIDDEN_TENANT_ERROR) {
        const redirectTenant = detail.redirect_tenant.trim();
        redirectForForbiddenTenant(redirectTenant);
    }
}

function checkForToastErrors(data) {
    if (data && data.error === "Bad Request") {
        if (data.message.errorCode === "terminated_client_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "terminatedClientModification",
            });
        } else if (data.message.errorCode === "archived_member_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "membersArchivedModifcation",
            });
        } else if (data.message.errorCode === "archived_client_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "clientArchivedModification",
            });
        } else if (data.message.errorCode === "archived_division_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "divisionArchivedModification",
            });
        } else if (data.message.errorCode === "archived_class_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "classArchivedModification",
            });
        } else if (data.message.errorCode === "archived_dependent_person_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "dependentPersonArchivedModification",
            });
        }
    }
}

function redirectForForbiddenTenant(tenant) {
    let url = new URL(window.location.href);
    url.hostname = tenant + "." + url.hostname.split(".").slice(1).join(".");
    url.pathname = "/dashboard";
    url.search = "";
    window.location.href = url;
}
function redirectTo(path) {
    window.history.pushState(null, document.title, path);
    window.history.go();
}



// WEBPACK FOOTER //
// ./utils/simpleFetch.js